/* @flow */

import React, { useState } from 'react';
import { useIntl, defineMessages } from 'react-intl';

import FolderIcon from 'dibs-icons/exports/Folder';

// Helpers
import classnames from 'classnames';

// Styles
import styles from './styles.scss';

// Types
type FolderIconWrapperProps = {
    additionalIconClass?: string,
    additionalButtonClass?: string,
    disabledButton: boolean,
    iconPosition: string,
    iconText?: string,
    isInFolder: boolean,
    isAnimated?: boolean,
    isStrokeWidthHeavy?: boolean,
    type?: 'outline' | 'button',
    onAnimationEnd?: (event: SyntheticEvent<*>) => void,
    onClick: (event: SyntheticEvent<*>) => void,
};

const messages = defineMessages({
    label: {
        id: 'dibs-portfolio-folder.FolderWrapperIcon.label',
        defaultMessage: 'Save to folder',
    },
});

const FolderIconWrapper = (props: FolderIconWrapperProps) => {
    const intl = useIntl();
    const [isActive, setIsActive] = useState(false);
    const isButton = props.iconPosition === 'relative' || props.iconText;
    const iconClasses = classnames(styles.icon, props.additionalIconClass, {
        [styles.isIcon]: !isButton,
        [styles.isButton]: isButton,
        [styles.isAnimated]: !isButton && props.isAnimated,
        [styles.isFilled]: props.isInFolder,
        [styles.isStrokeWidthHeavy]: props.isStrokeWidthHeavy,
    });
    const iconShadowClasses = classnames(styles.iconShadow, {
        [styles.isAnimated]: props.isAnimated,
    });

    const dataTn = props.isInFolder ? 'folder-saved-icon' : 'folder-save-icon';

    if (props.iconPosition === 'relative' || props.iconText) {
        const buttonClasses = classnames(styles.iconButton, props.additionalButtonClass, {
            [styles.disabled]: props.disabledButton,
        });

        const buttonIconClasses = classnames(styles.icon, props.additionalIconClass);

        return (
            <button className={buttonClasses} data-tn="add-to-folder" onClick={props.onClick}>
                <FolderIcon className={buttonIconClasses} />
                {props.iconText && <span className={styles.text}>{props.iconText}</span>}
            </button>
        );
    }
    function toggleActive(active) {
        if (props.type === 'button') {
            setIsActive(active);
        }
    }
    return (
        <button
            aria-label={intl.formatMessage(messages.label)}
            className={classnames(styles.iconWrapper, props.additionalButtonClass, {
                [styles[props.type]]: props.type,
                [styles.isActive]: isActive,
                [styles.isStrokeWidthHeavy]: props.isStrokeWidthHeavy,
            })}
            onTouchStart={() => toggleActive(true)}
            onTouchEnd={() => toggleActive(false)}
            onClick={props.onClick}
            data-tn={dataTn}
        >
            <div
                className={classnames(styles.folder, {
                    [styles[props.type]]: props.type,
                })}
            >
                <FolderIcon className={iconClasses} />
                <div className={iconShadowClasses} onAnimationEnd={props.onAnimationEnd} />
            </div>
        </button>
    );
};

FolderIconWrapper.defaultProps = {
    disabledButton: false,
    iconPosition: 'absolute',
    isInFolder: false,
    onClick: () => {},
    type: 'outline',
    isStrokeWidthHeavy: false,
};

export default FolderIconWrapper;
